<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-15 16:59:31
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-16 14:36:49
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <p class="detail-tit">产品详情</p>
      <div class="title">
        {{ detailList.bankName
        }}{{ businessOutlets ? `-${businessOutlets}` : '' }}
      </div>
      <p class="tit-bor-left">农机购置贷</p>
      <table class="table-static">
        <tr>
          <th>适用地区</th>
          <td colspan="3">
            {{ detailList.region ? detailList.region : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>货款额度</th>
          <td>
            {{
              detailList.minLoanLimit == 0 || detailList.minLoanLimit
                ? `${detailList.minLoanLimit} ~ ${detailList.maxLoanLimit} 万`
                : ' - '
            }}
          </td>
          <th>货款期限</th>
          <td>
            {{
              detailList.minLoanTerm == 0 || detailList.minLoanTerm
                ? `${detailList.minLoanTerm} ~ ${detailList.maxLoanTerm} 个月`
                : ' - '
            }}
          </td>
        </tr>
        <tr>
          <th>年利率</th>
          <td>
            {{
              detailList.minYearRate
                ? `${detailList.minYearRate} % ~ ${detailList.maxYearRate} %`
                : ' - '
            }}
          </td>
          <th>政府贴息</th>
          <td>
            {{
              detailList.loanSubsidyLimit
                ? `${detailList.loanSubsidyLimit}`
                : '无'
            }}
          </td>
        </tr>
        <tr>
          <th>产品介绍</th>
          <td colspan="3">
            {{
              detailList.productIntroduction
                ? detailList.productIntroduction
                : ' - '
            }}
          </td>
        </tr>
        <tr>
          <th>适用对象</th>
          <td colspan="3">
            {{ detailList.useObjStr ? detailList.useObjStr : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>产品优势</th>
          <td colspan="3">
            {{
              detailList.productAdvantages
                ? detailList.productAdvantages
                : ' - '
            }}
          </td>
        </tr>
        <tr>
          <th>申请材料</th>
          <td colspan="3">
            {{
              detailList.applyInformation ? detailList.applyInformation : ' - '
            }}
          </td>
        </tr>
        <tr>
          <th>担保形式</th>
          <td colspan="3">
            {{ detailList.guaranteeFormName }}
            <span v-if="detailList.guaranteeForm"
              >，{{ detailList.guaranteeForm }}</span
            >
          </td>
        </tr>
        <tr>
          <th>还款方式</th>
          <td colspan="3">
            {{ detailList.repaymentMethodName }}
            <span v-if="detailList.repaymentMethod"
              >，{{ detailList.repaymentMethod }}</span
            >
          </td>
        </tr>
        <tr>
          <th>其他</th>
          <td colspan="3">
            {{ detailList.remark ? detailList.remark : ' - ' }}
          </td>
        </tr>
        <tr>
          <th>申请流程</th>
          <td colspan="3">
            {{ detailList.applyCourse ? detailList.applyCourse : ' - ' }}
          </td>
        </tr>
      </table>
    </div>
  </el-main>
</template>
<script>
export default {
  name: 'ProductViewDetail',
  data() {
    return {
      detailList: {}, // 详情列表
      loanSubsidyLimitNum: '', // 年利率
      businessOutlets: '', // 业务网点
    }
  },
  created() {
    this.getSelectOneList()
    this.businessOutlets = this.$route.query.businessOutlets
  },
  methods: {
    getSelectOneList() {
      let params = {
        id: this.$route.query.id,
      }
      this.$http.bank.getSelectOneList(params).then((res) => {
        this.detailList = res.data
        let num = res.data.maxYearRate / res.data.minYearRate
        this.loanSubsidyLimitNum = Math.round(num * 100) / 100
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/common.scss';
.main {
  .detail-tit {
    font-size: 20px;
    font-weight: bold;
    color: #018388;
    padding-bottom: 15px;
    border-bottom: 1px solid #e9ebee;
  }
  .title {
    font-size: 18px;
    color: #212121;
    font-weight: bold;
    margin: 18px 0;
  }
  .tit-bor-left {
    margin-bottom: 11px;
  }
}
</style>
